import { sqftLabelFor } from "./useBookingForm";

/** Sticky order-summary sidebar shown next to every step. */
export function BookingSummary({ sqft, quote }) {
  return (
    <div className="lg:col-span-1">
      <div className="border border-white/50 bg-card/70 backdrop-blur-xl p-6 sticky top-28 shadow-sm" data-testid="cart-summary">
        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-slate-500">Order summary</div>
        {sqft && <div className="text-sm text-slate-500 mt-3 font-mono">{sqftLabelFor(sqft)}</div>}
        <div className="mt-4 space-y-3">
          {quote?.line_items?.length ? quote.line_items.map((li) => (
            <div key={li.id} className="flex justify-between text-sm">
              <span className="text-slate-700">{li.name}{li.qty > 1 ? ` ×${li.qty}` : ""}</span>
              <span className="font-mono">${li.amount}</span>
            </div>
          )) : <div className="text-sm text-slate-400">No services added yet.</div>}
        </div>
        {quote && (
          <div className="border-t border-border mt-5 pt-5 space-y-2 text-sm">
            <div className="flex justify-between text-slate-500"><span>Subtotal</span><span className="font-mono">${quote.subtotal}</span></div>
            {quote.discount > 0 && <div className="flex justify-between text-emerald-700"><span>Discount</span><span className="font-mono">-${quote.discount}</span></div>}
            <div className="flex justify-between items-baseline pt-2"><span className="font-medium">Estimated total</span><span data-testid="live-order-total-price" className="font-display text-3xl">${quote.total}</span></div>
          </div>
        )}
      </div>
    </div>
  );
}
